export const TOO_LARGE_TO_DELIVER = 'TOO_LARGE_TO_DELIVER'
